/**
 * Gestor de Alertas y Errores Globales
 * Configura el comportamiento de SweetAlert2 y la captura de excepciones no controladas.
 * Cumple con .idx-rules.md: modular y funciones cortas.
 */

/**
 * Inicializa el override global de alertas y captura de excepciones.
 */
export function initAlertsAndErrors() {
  // Manejador de errores JS no controlados
  window.addEventListener('error', (e) => {
    console.error('Error no manejado:', e.error);
    alert(`Error: ${e.message}\nEn: ${e.filename}:${e.lineno}`);
  });

  // Manejador de rechazos de promesas no controlados
  window.addEventListener('unhandledrejection', (e) => {
    console.error('Promesa rechazada:', e.reason);
    const msg = String(e.reason?.message || e.reason);
    if (msg.includes('Video stream has ended') || msg.includes('NotFoundException')) {
      return;
    }
    alert(`Promesa rechazada: ${msg}`);
  });

  // Override de alert nativo por SweetAlert2
  window.alert = (message) => {
    const icon = determineAlertIcon(message);
    const title = determineAlertTitle(icon);
    const cleanMessage = message.replace(/^[🟢🔴⚡❌✅🛑💬⚠️]\s*/, '');
    const isLight = document.documentElement.classList.contains('light-mode');

    if (window.Swal) {
      window.Swal.fire({
        title,
        text: cleanMessage,
        icon,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#2563eb',
        background: isLight ? '#ffffff' : '#171f33',
        color: isLight ? '#0f172a' : '#dae2fd'
      });
    } else {
      console.warn('SweetAlert2 no está cargado. Usando fallback de consola para:', message);
    }
  };
}

/**
 * Determina el icono SweetAlert2 a usar según el contenido del mensaje.
 */
function determineAlertIcon(message) {
  if (/exitosamente|exitoso|✅|🟢|⚡/.test(message)) {
    return 'success';
  }
  if (/incorrectas|denegado|Error|🔴|❌|obligatorios|inválido/.test(message)) {
    return 'error';
  }
  if (/Soporte/.test(message)) {
    return 'question';
  }
  return 'info';
}

/**
 * Determina el título de la alerta según el tipo de icono.
 */
function determineAlertTitle(icon) {
  switch (icon) {
    case 'success': return 'Éxito';
    case 'error': return 'Atención';
    case 'question': return 'Soporte';
    default: return 'Información';
  }
}
